<template>
  <div class="collar">
    <!-- “collar”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeCompany="changeCompany"
      @productCodeChange="productCodeChange"
      @changeDepartment="changeDepartment"
      @changeGoodsType="changeGoodsType"
      @projectChange="projectChange"
      @periodChange="periodChange"
    ></sirui-search>
    <!-- collar -->
    <div class="main-content">
      <el-row>
        <el-col :span="2">
          <div class="grid-content bg-purple-dark">
            {{ this.$t('costConfirmationList.column.settlementCountUnitEN') }}
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            <el-input
              :placeholder="this.$t('costConfirmationList.placeholder.autoRowTotal')"
              v-model="settlementCount"
              :disabled="true"
            >
            </el-input>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            {{ this.$t('costConfirmationList.column.settlementAmountWithoutTaxUnitEN') }}
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            <el-input
              :placeholder="this.$t('costConfirmationList.placeholder.autoRowTotal')"
              v-model="settlementAmountWithoutTax"
              :disabled="true"
            >
            </el-input>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            {{ this.$t('costConfirmationList.column.settlementAmountWithTaxUnitEN') }}
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            <el-input
              :placeholder="this.$t('costConfirmationList.placeholder.autoRowTotal')"
              v-model="settlementAmountWithTax"
              :disabled="true"
            >
            </el-input>
          </div>
        </el-col>
      </el-row>
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          type="index"
          :title="$t('costConfirmationList.column.index')"
          width="80"
        ></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <el-dialog
      :title="this.$t('costConfirmationList.form.importPeriodNameSelect')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="350px"
    >
      <base-form
        v-model="baseData"
        :options="options"
        ref="baseData"
        @input="handleChangeBaseData"
        label-width="100px"
      ></base-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="handleImport()">{{
          $t('dialog.confirm')
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <!-- <sirui-upload :action="action" ref="SiruiUpload" :data="token"></sirui-upload> -->
    <sirui-upload
      :data="importData"
      :action="importUrl"
      fileList=".xls,.xlsx"
      v-on:getData="getData"
      ref="siruiUpload"
    >
    </sirui-upload>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/productCenter/costConfirm.js';
  import DataBaseAPI from '@/api/dataBase';
  import tableMixins from '@/common/mixins/table.js';
  import { filterEmpty } from '@/common/js/util';
  import siruiUpload from '@/components/SiruiUpload';
  import baseForm from '@/components/form/base-form';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'costConfirmationList',
    components: {
      siruiUpload,
      baseForm,
    },
    mixins: [tableMixins],

    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.userInfo.access_token,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          tenantCode: this.userInfo.userInfo.tenantCode,
          businessCompanyCode: this.userInfo.userInfo.companyCode, //公司信息
          businessCompanyName: this.userInfo.userInfo.companyName, //公司信息
          businessDepartmentCode: this.userInfo.userInfo.departmentCode, //部门信息
          businessDepartmentName: this.userInfo.userInfo.departmentCode, //部门信息
          createPersonNo: this.userInfo.userInfo.userCode, //操作人
          createPersonName: this.userInfo.userInfo.userName, //操作人
        };
      },
      baseUrl() {
        return baseUrl;
      },
      user() {
        return this.userInfo.userInfo;
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //   公司代码
          {
            prop: 'businessCompanyCode',
            name: this.$t('costConfirmationList.column.businessCompanyCode'),
            type: 'select',
            options: this.slipCompanyList,
            changeMethod: 'changeCompany',
          },
          //   事业部门
          {
            prop: 'businessDepartmentCode',
            name: this.$t('costConfirmationList.column.businessDepartmentCode'),
            type: 'select',
            options: this.slipDepartmentList,
            changeMethod: 'changeDepartment',
          },
          //操作人
          {
            prop: 'createPersonNo',
            type: 'searchTableSpec',
            isMultiple: true,
            name: this.$t('costConfirmationList.column.createPersonNo'),
            searchType: 'personnel',
          },
          {
            // 结算周期
            prop: 'periodName',
            name: this.$t('costConfirmationList.column.periodName'),
            type: 'searchTableSpec',
            searchType: 'pdPeriod',
            isMultiple: true,
            extraData: {
              projectCode: this.query.projectCode,
            },
            currentValue: this.query.periodName,
            changeMethod: 'periodChange',
          },
          //供应商--合作伙伴
          {
            prop: 'partnerCode',
            type: 'input',
            name: this.$t('costConfirmationList.column.partnerCode'),
            //searchType: "supplier",
            //isMultiple: true,
            //getSearchCode: 'partnerCode',
          },
          // 创建日期
          {
            prop: 'createDateStart',
            name: this.$t('costConfirmationList.column.createDateStart'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'createDateEnd',
            name: this.$t('costConfirmationList.column.createDateEnd'),
            type: 'endDaterangePicker',
          },
          // 合同日期
          {
            prop: 'contractDateStart',
            name: this.$t('costConfirmationList.column.contractDateStart'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'contractDateEnd',
            name: this.$t('costConfirmationList.column.contractDateEnd'),
            type: 'endDaterangePicker',
          },
          /* // 创建日期
        {
          prop: "createDate",
          name: this.$t("costConfirmationList.column.createDate"),
          type: "daterange",
        },
        // 合同日期
        {
          prop: "contractDate",
          name: this.$t("costConfirmationList.column.contractDate"),
          type: "daterange"
        }, */
          //商品大类
          /* {
          prop: "goodsType",
          name: this.$t("costConfirmationList.column.goodsType"),
          type: "select",
          options: this.goodsTypeList,
          changeMethod: "changeGoodsType"
        }, */
          //商品编码
          {
            prop: 'productName',
            name: this.$t('costConfirmationList.column.productName'),
            type: 'searchTableSpec',
            searchType: 'produceProduct',
            changeMethod: 'productCodeChange',
            isMultiple: true,
            extraData: {
              productClass: '0',
            },
            //options: this.productDetailList
          },
          // 结算数量
          {
            prop: ['settlementCountCondition', 'settlementCount'],
            name: this.$t('costConfirmationList.column.settlementCount'),
            type: 'selectInput',
            inputType: 'inputNumber',
            maxlength: 20,
            options: this.optionSelect,
          },
          // 含税结算金额
          {
            prop: ['settlementAmountWithTaxCondition', 'settlementAmountWithTax'],
            name: this.$t('costConfirmationList.column.settlementAmountWithTax'),
            type: 'selectInput',
            inputType: 'inputNumber',
            maxlength: 20,
            options: this.optionSelect,
          },
          // 不含税结算金额
          {
            prop: ['settlementAmountWithoutTaxCondition', 'settlementAmountWithoutTax'],
            name: this.$t('costConfirmationList.column.settlementAmountWithoutTax'),
            type: 'selectInput',
            inputType: 'inputNumber',
            maxlength: 20,
            options: this.optionSelect,
          },
          // 成本确认单号
          {
            name: this.$t('costConfirmationList.column.confirmNo'),
            prop: 'confirmNo',
            type: 'input',
          },
          // 含税结算单价
          {
            prop: ['settlementPriceWithTaxCondition', 'settlementPriceWithTax'],
            name: this.$t('costConfirmationList.column.settlementPriceWithTax'),
            type: 'selectInput',
            inputType: 'inputNumber',
            maxlength: 20,
            options: this.optionSelect,
          },
          // 不含税结算单价
          {
            prop: ['settlementPriceWithoutTaxCondition', 'settlementPriceWithoutTax'],
            name: this.$t('costConfirmationList.column.settlementPriceWithoutTax'),
            type: 'selectInput',
            inputType: 'inputNumber',
            maxlength: 20,
            options: this.optionSelect,
          },
          {
            // 项目名称
            prop: 'projectCode',
            name: this.$t('costConfirmationList.column.projectName'),
            type: 'dict',
            dictType: 'produce_product_proname',
            changeMethod: 'projectChange',
          },

          /* { // 成本确认年度
          prop: "confirmYear", 
          name: this.$t('costConfirmationList.column.confirmYear'), 
          type: "select",
          options: this.yearList 
        },
        {
          // 成本确认月份
          prop: "confirmMonth",
          name: this.$t("costConfirmationList.column.confirmMonth"),
          type: "select",
          options: this.monthList(),
        }, */
        ];
      },
      options() {
        return [
          {
            // 账期
            prop: 'periodName',
            label: this.$t('costConfirmationList.label.periodName'),
            type: 'searchTable',
            searchType: 'pdPeriod',
            required: true,
            isMultiple: true,
            span: 18,
            extraData: {
              projectCode: this.baseData.projectCode,
              periodStatus: 'opened',
            },
            currentValue: this.baseData.periodName,
          },
        ];
      },
    },
    data() {
      return {
        action: API.IMPORT_PD_COST_CONFIRM_DETAILS,
        dialogAdd: false,
        loading: false,
        importData: {}, // 导入参数
        importUrl: '', // 导入地址
        query: {
          businessCompanyCode: null, //公司信息
          businessDepartmentCode: null, //部门信息
          createPersonNo: null, //操作人
          partnerCode: null, //供应商
          //createDate: null, //创建日期
          createDateStart: null, //创建日期起
          createDateEnd: null, //创建日期止
          //contractDate: null, //合同日期
          contractDateStart: null, //合同日期起
          contractDateEnd: null, //合同日期止
          goodsType: null, //商品大类
          productCode: null, //商品编码
          settlementCountCondition: null, //
          settlementCount: undefined, //结算数量{KG}
          settlementAmountWithTaxCondition: null, //
          settlementAmountWithTax: undefined, //含税结算金额{¥}
          settlementAmountWithoutTaxCondition: null, //
          settlementAmountWithoutTax: undefined, //不含税结算金额{¥}
          confirmNo: null, //成本确认单号
          settlementPriceWithTaxCondition: null, //
          settlementPriceWithTax: undefined, //含税结算单价{¥}
          settlementPriceWithoutTaxCondition: null, //
          settlementPriceWithoutTax: undefined, //不含税结算单价{¥}
          projectCode: null, //项目名称编码
          projectName: null, //项目名称
          periodCode: null, //成本确认账期编码
          periodName: null, //成本确认账期
          //confirmYear: null, //成本确认年度
          //confirmMonth: null, //成本确认月份
        },
        baseData: {
          projectCode: null, //项目名称编码
          projectName: null, //项目名称
          periodCode: null, //账期编码
          periodName: null, //账期
        },
        settlementCount: null, //查询结果 结算数量(KG)
        settlementAmountWithoutTax: null, //查询结果 不含税结算金额(￥)
        settlementAmountWithTax: null, //查询结果 含税结算金额(￥)
        tableData: [], //列表数据
        slipCompanyList: [], // 公司
        slipDepartmentList: [], // 部门
        goodsTypeList: [], //商品大类
        yearList: [], //年度
        monthList() {
          //月份
          var mon = [];
          for (let i = 1; i < 13; i++) {
            mon.push({ label: i + this.$t('fundFrecast.column.month'), value: i });
          }
          return mon;
        },
        optionSelect: [
          { value: 1, label: this.$t('costConfirmationList.search.equal') }, //等于
          { value: 2, label: this.$t('costConfirmationList.search.notEqual') }, //不等于
          { value: 3, label: this.$t('costConfirmationList.search.gt') }, //大于
          { value: 4, label: this.$t('costConfirmationList.search.lt') }, //小于
        ], //大于，小于，不等于，等于
        menuButtonList: [], //按钮
        columnList: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          /* {
          field: "goodsType",
          title: "costConfirmationList.column.goodsTypeName",
          visible: true,
          width: 140,
          dictType: 'productType',
        }, */
          {
            field: 'productName',
            title: 'costConfirmationList.column.productName',
            visible: true,
            width: 140,
          },
          {
            field: 'productCode',
            title: 'costConfirmationList.column.productCode',
            visible: true,
            width: 140,
          },
          {
            field: 'confirmNo',
            title: 'costConfirmationList.column.confirmNo',
            visible: true,
            width: 140,
          },
          {
            field: 'partnerName',
            title: 'costConfirmationList.column.partnerCode',
            visible: true,
            width: 140,
          },
          {
            field: 'contractDate',
            title: 'costConfirmationList.column.contractDate',
            visible: true,
            width: 140,
          },
          /* {
          field: "projectName",
          title: "costConfirmationList.column.projectName",
          visible: true,
          width: 140
        },
        {
          field: "periodName",
          title: "costConfirmationList.column.periodName",
          visible: true,
          width: 140
        }, */
          /* {
          field: "confirmYearMonth",
          title: "costConfirmationList.column.confirmMonth",
          visible: true,
          width: 140
        }, */
          {
            field: 'settlementCount',
            title: 'costConfirmationList.column.settlementCount',
            visible: true,
            width: 140,
          },
          {
            field: 'settlementAmountWithTax',
            title: 'costConfirmationList.column.settlementAmountWithTax',
            visible: true,
            width: 140,
          },
          {
            field: 'settlementPriceWithTax',
            title: 'costConfirmationList.column.settlementPriceWithTax',
            visible: true,
            width: 140,
          },
          {
            field: 'settlementAmountWithoutTax',
            title: 'costConfirmationList.column.settlementAmountWithoutTax',
            visible: true,
            width: 140,
          },
          {
            field: 'settlementPriceWithoutTax',
            title: 'costConfirmationList.column.settlementPriceWithoutTax',
            visible: true,
            width: 140,
          },
          {
            field: 'createPersonName',
            title: 'costConfirmationList.column.createPersonNo',
            visible: true,
            width: 140,
          },
          {
            field: 'businessDepartmentName',
            title: 'costConfirmationList.column.businessDepartmentCode',
            visible: true,
            width: 140,
          },
          {
            field: 'businessCompanyName',
            title: 'costConfirmationList.column.businessCompanyCode',
            visible: true,
            width: 140,
          },
        ],
      };
    },
    mounted() {
      this.getButtonList();
      this.getDictList();
      // this.getGoodsList();
      this.getCurrentDepartment();
      this.getYearList();
      this.setImport();
      this.$nextTick(() => {
        //设置导入参数
        this.setImport();
      });
    },
    methods: {
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
        });
        return filterEmpty(result);
      },
      //查询结果
      searchBtnClick() {
        const params = this.getQuery();
        if (Object.keys(params).length == 2) {
          this.$message({
            showClose: true,
            message: this.$t('search.nosearchError'),
            type: 'error',
          });
          return;
        }
        this.getData();
      },
      // 获取列表数据
      getData() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        this.query.createPersonNo =
          this.query.createPersonNo && this.query.createPersonNo[0]
            ? this.query.createPersonNo[0].id
            : '';
        if (!this.query.periodName) {
          return this.tips('noPeriodName', 'error');
        }
        const params = { ...this.query, pageNum, pageSize };
        this.load = true;
        this.$axios.post(API.QUERY_PD_COST_CONFIRM, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.pdCostConfirmLists.records;
            this.settlementCount = res.data.data.totalSettlementCount;
            this.settlementAmountWithTax = res.data.data.totalSettlementAmountWithTax;
            this.settlementAmountWithoutTax = res.data.data.totalSettlementAmountWithoutTax;
            this.$refs.siruiTable.setPageTotal(res.data.data.pdCostConfirmLists.total);
            /* let settlementCountTemp=0; //查询结果 结算数量(KG)
          let settlementAmountWithoutTaxTemp=0;//查询结果 不含税结算金额(￥)
          let settlementAmountWithTaxTemp=0;//查询结果 含税结算金额(￥)
          for(let item of this.tableData){
            settlementCountTemp =this.$cal.accAdd(settlementCountTemp,item.settlementCount);
            settlementAmountWithoutTaxTemp =this.$cal.accAdd(settlementAmountWithoutTaxTemp,item.settlementAmountWithoutTax);
            settlementAmountWithTaxTemp =this.$cal.accAdd(settlementAmountWithTaxTemp,item.settlementAmountWithTax);
          }
          this.settlementCount = settlementCountTemp;
          this.settlementAmountWithoutTax = settlementAmountWithoutTaxTemp;
          this.settlementAmountWithTax = settlementAmountWithTaxTemp; */
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取当前登录用户所在的公司部门
      async getCurrentDepartment() {
        let personDepartmentInfo = [];
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };

        await this.$axios.post(DataBaseAPI.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            personDepartmentInfo = res.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });

            this.query.businessDepartmentCode = personDepartmentInfo[0].value;
            this.slipDepartmentList = personDepartmentInfo;
          }
        });
        //this.getData();
      },
      //获取按钮
      getButtonList() {
        this.menuButtonList = [
          {
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-plus',
              buttonUrl: 'add',
            },
            label: this.$t('costConfirmationList.router.add'),
          },
          {
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-upload2',
              buttonUrl: 'importData',
            },
            label: this.$t('costConfirmationList.router.importData'),
          },
          {
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-delete',
              buttonUrl: 'del',
            },
            label: this.$t('costConfirmationList.router.del'),
          },
          {
            type: '0',
            attributes: {
              buttonStyle: 'el-icon-download',
              buttonUrl: 'export',
            },
            label: this.$t('costConfirmationList.router.export'),
          },
        ];
      },
      // 公司名称
      getDictList() {
        this.$axios
          .get(DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.slipCompanyList = res.data.data;
            }
          });
      },
      //切换公司
      changeCompany(val) {
        this.slipDepartmentList = [];
        this.query.businessDepartmentCode = '';
        this.slipCompanyList.find((item) => {
          if (item.value === val.val) {
            this.initDepartment();
          }
        });
      },
      //业务部门
      initDepartment() {
        this.$axios
          .post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + this.query.businessCompanyCode)
          .then((res) => {
            if (0 == res.data.code) {
              this.slipDepartmentList = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      //切换部门
      changeDepartment(val) {
        this.goodsTypeList = [];
        this.query.goodsType = '';
        this.slipDepartmentList.find((item) => {
          if (item.value === val.val) {
            this.getGoodsList();
          }
        });
      },
      projectChange() {
        // 切换项目
        this.query.periodCode = this.query.periodName = null;
      },
      periodChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.query.periodCode = res[0].periodCode;
          this.query.periodName = res[0].periodName;
        } else {
          this.query.periodCode = this.query.periodName = null;
        }
        if (res[0].periodStatus == 'closed') {
          //关闭的账期不能对数据进行增删改
          this.menuButtonList.forEach((item) => {
            if (['del'].indexOf(item.attributes.buttonUrl) > -1) {
              item.isDisabled = true;
            } else {
              item.isDisabled = false;
            }
          });
        } else {
          this.menuButtonList.forEach((item) => {
            item.isDisabled = false;
          });
        }
      },
      //商品大类
      async getGoodsList() {
        const selectStatus = await this.$axios.post(DataBaseAPI.GOODS_LIST_API, {
          departmentCode: this.query.businessDepartmentCode,
        });
        if (selectStatus.data.code == 0) {
          this.goodsTypeList = selectStatus.data.data;
        }
      },
      productCodeChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.query.productCode = res[0].productCode;
        } else {
          this.query.productCode = null;
        }
      },
      //切换商品大类
      changeGoodsType(val) {
        this.productDetailList = [];
        this.query.productCode = '';
        this.goodsTypeList.find((item) => {
          if (item.value === val.val) {
            this.getProductDetail();
          }
        });
      },
      //商品编号
      async getProductDetail() {
        const selectStatus = await this.$axios.get(
          DataBaseAPI.LIST_DETAIL_PRODUCT + '/' + this.query.goodsType
        );
        if (selectStatus.data.code == 0) {
          this.productDetailList = selectStatus.data.data;
        }
      },
      // 表单变化
      handleChangeBaseData(value, prop) {
        if (prop == 'projectCode') {
          this.baseData.periodCode = this.baseData.periodName = null;
          this.baseData.projectCode = value.projectCode;
          this.baseData.projectName = this.$baseRequest.getDictValueByType(
            'produce_product_proname',
            value.projectCode
          );
        }
        if (prop == 'periodName') {
          let res = value.periodName;
          if (res && res.length > 0) {
            this.baseData.projectCode = res[0].projectCode;
            this.baseData.projectName = res[0].projectName;
            this.baseData.periodCode = res[0].periodCode;
            this.baseData.periodName = res[0].periodName;
          } else {
            this.baseData.periodCode = this.baseData.periodName = null;
          }
        }
      },
      // 按钮
      chooseClick(type) {
        if (type === 'add') {
          let path = {
            path: '/production/costConfirmationAdd',
            name: 'costConfirmationAdd',
            meta: {
              keepAlive: true,
              title: this.$t('costConfirmationList.title.add'),
            },
            query: {},
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type === 'del') {
          //批量删除
          this.handleDelete();
        } else if (type == 'importData') {
          // 导入
          this.dialogAdd = true;
        } else {
          if (this.tableData && this.tableData.length === 0) {
            return this.tips('noExport');
          }
          this.handleExport();
        }
      },
      //获取当前年度
      getYearList() {
        let date = new Date();
        let year = date.getFullYear() + 1;
        for (let i = 0; i < 5; i++) {
          year = year - 1;
          let object = { value: `${year}` + '', label: year + '' };
          this.yearList.push(object);
        }
      },
      //列表双击p
      dblclickEvent(value) {
        console.log(value.row.contractDate);
        /* let path = {
        path: "/production/costConfirmationDetails",
        name: "costConfirmationDetails",
        meta: {
          keepAlive: false,
          title: "成本确认单明细详情"
        },
        query: {}
      };
      this.$store.dispatch("tagsView/addTabView", path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      }); */
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getCurrentDepartment();
      },
      // 设置导入配置
      setImport() {
        this.importUrl = API.IMPORT_PD_COST_CONFIRM_DETAILS;
        let { tenantCode, access_token, companyCode, companyName, departmentCode, departmentName } =
          this.userInfo.userInfo;
        let businessCompanyCode = this.userInfo.userInfo.companyCode; //公司信息
        let businessCompanyName = this.userInfo.userInfo.companyName; //公司信息
        let businessDepartmentCode = this.userInfo.userInfo.departmentCode; //部门信息
        let businessDepartmentName = this.userInfo.userInfo.departmentCode; //部门信息
        let createPersonNo = this.userInfo.userInfo.userCode; //操作人
        let createPersonName = this.userInfo.userInfo.userName; //操作人
        this.importData = {
          tenantCode,
          access_token,
          companyCode,
          companyName,
          departmentCode,
          departmentName,
          businessCompanyCode,
          businessCompanyName,
          businessDepartmentCode,
          businessDepartmentName,
          createPersonNo,
          createPersonName,
        };
      },
      // 返回表单数据
      exportBaseData() {
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
      handleImport() {
        // 导入
        let baseData = this.exportBaseData();
        if (baseData) {
          this.importData = Object.assign(this.importData, this.baseData);
          this.$refs.siruiUpload.openDialog(true);
          this.dialogAdd = false;
        }
      },
      //删除
      handleDelete() {
        if (this.multipleSelection.length > 0) {
          let ids = [];
          for (let item of this.multipleSelection) {
            ids.push(item.confirmNo);
          }
          const params = { confirmNos: ids };
          this.$confirmAction(this.$t('confirm.delete'))
            .then(() => {
              this.$axios.post(API.DELETE_PD_COST_CONFIRM_DETAILS, params).then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: this.$t('costConfirmationList.message.deleteSuccess'),
                    type: 'success',
                  });
                  this.multipleSelection = [];
                  this.$refs.siruiTable.clearCheckboxRow();
                  this.resetBtnClick();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('costConfirmationList.message.pleaseSelectOne'),
            type: 'error',
          });
        }
      },
      //导出
      handleExport() {
        // console.log('导出')
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'idList=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.EXPORT_PD_COST_CONFIRM_DETAILS}?${str}access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.query);
          window.location.href = `${this.baseUrl}${API.EXPORT_PD_COST_CONFIRM_DETAILS}?${params}&access_token=${this.token.access_token}`;
        }
      },
      async getDepartMentName(departmentCode) {
        let res = await this.$baseRequest.getDepartmentTree();
        console.log(res);
        return res.find((item) => item.attributes.departmentCode == departmentCode).attributes
          .departmentName;
        //   this.$baseRequest.getDepartmentTree().then(res=>{
        //     return res.find(item=>item.attributes.departmentCode==departmentCode).attributes.departmentName;
        // });
      },
      //提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`costConfirmationList.message.${info}`),
          type: 'error',
        });
      },
    },
  };
</script>
<style scoped>
  .el-row {
    margin-bottom: 10px;
    font-size: 12px;
    text-align: right;
    vertical-align: middle;
    color: #606266;
  }
  .el-col {
    border-radius: 4px;
    line-height: 32px;
  }
  .grid-content {
    padding: 0 12px 0 0 !important;
  }
</style>
